import * as React from 'react'

import { sanitizeEmptyValues } from 'react-admin'
import { Form } from 'react-final-form'
import arrayMutators from 'final-form-arrays'

export const CustomForm = ({ render, save, record, version }) => {
  const submit = (values) => {
    save(sanitizeEmptyValues(record, values))
  }
  return (
    <Form
      initialValues={record}
      onSubmit={submit}
      mutators={{ ...arrayMutators }}
      subscription={{
        submitting: true,
        pristine: true,
        valid: true,
        invalid: true,
      }}
      key={version}
      keepDirtyOnReinitialize
      render={render}
    />
  )
}
